import axios from 'axios';

import type { Maybe } from '../graph/MogulMarketplace';

const IPFS_PREFIX = 'ipfs://';
const BASE_URL = 'https://mogul.mypinata.cloud/ipfs/';
const IPFS_IO_URL = 'https://ipfs.io/ipfs/';

export const translateIpfsToPinata = (uri: Maybe<string> | undefined) => {
  if (uri == null) {
    return '';
  }
  if (uri.startsWith(IPFS_IO_URL)) {
    return uri;
  }

  const isIpfs = uri.startsWith(IPFS_PREFIX);
  if (!isIpfs && !uri.startsWith('Qm')) {
    return '';
  }
  if (uri.startsWith('Qm')) {
    return `${BASE_URL}${uri}`;
  }
  return `${BASE_URL}${uri.slice(IPFS_PREFIX.length)}`;
};

export const translateIpfsToIpfsio = (uri: Maybe<string> | undefined) => {
  if (uri == null) {
    return '';
  }
  if (uri.startsWith(IPFS_IO_URL)) {
    return uri;
  }

  const isIpfs = uri.startsWith(IPFS_PREFIX);
  if (!isIpfs && !uri.startsWith('Qm')) {
    return '';
  }
  if (uri.startsWith('Qm')) {
    return `${IPFS_IO_URL}${uri}`;
  }
  return `${IPFS_IO_URL}${uri.slice(IPFS_PREFIX.length)}`;
};

export const configureNftCatalogService = () => ({
  fetchAndParseMetadata: async (uri: string) => {
    const pinataUrl = translateIpfsToPinata(uri);
    const { data } = await axios.get<{ [key: string]: string }>(pinataUrl);

    const result: { [key: string]: string } = {};
    Object.keys(data).forEach((key: string) => {
      result[key] =
        typeof data[key] === 'string' && data[key].startsWith(IPFS_PREFIX)
          ? translateIpfsToPinata(data[key])
          : data[key];
    });
    return result;
  },
});

export const nftCatalogService = configureNftCatalogService();
